export default "__VITE_ASSET__0Px20o7H__"